var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticClass:"prelogin-container"},[_c('MainBackground'),_c('el-image',{staticClass:"logo-img",attrs:{"src":require('@/assets/images/complife-group-logo-xl.jpg'),"fit":"contain"}}),_c('el-main',{staticClass:"prelogin-main"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }